exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ImageSpan__root___1hG7j {\n  background-repeat: no-repeat;\n  display: inline-block;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.ImageSpan__resize___2Uvix {\n  border: 1px dashed #78a300;\n  position: relative;\n  max-width: 100%;\n  display: inline-block;\n  line-height: 0;\n  top: -1px;\n  left: -1px;\n}\n\n.ImageSpan__resizeHandle___1fncE {\n  cursor: nwse-resize;\n  position: absolute;\n  z-index: 2;\n  line-height: 1;\n  bottom: -4px;\n  right: -5px;\n  border: 1px solid white;\n  background-color: #78a300;\n  width: 8px;\n  height: 8px;\n}\n", ""]);

// Exports
exports.locals = {
	"root": "ImageSpan__root___1hG7j",
	"resize": "ImageSpan__resize___2Uvix",
	"resizeHandle": "ImageSpan__resizeHandle___1fncE"
};


//////////////////
// WEBPACK FOOTER
// ../css-loader/dist/cjs.js??ref--2-1!../react-rte/lib/ui/ImageSpan.css
// module id = 2197
// module chunks = 25